import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-muted" }, "drag_indicator", -1)
const _hoisted_9 = { class: "ms-3" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = {
  key: 0,
  class: "ms-2 mt-2"
}
const _hoisted_12 = {
  key: 1,
  class: "ms-2 mt-2"
}
const _hoisted_13 = {
  key: 2,
  class: "ms-2 mt-2"
}
const _hoisted_14 = {
  key: 0,
  class: "d-flex w-100"
}
const _hoisted_15 = {
  key: 0,
  class: "sd-sm mx-auto"
}
const _hoisted_16 = { class: "text-nowrap" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons mx-auto p-button-icon" }, "content_copy", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" })
], -1)
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "w-100 position-relative" }
const _hoisted_22 = { class: "container-top-middle center" }
const _hoisted_23 = {
  key: 0,
  class: "sd-sm mx-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_25 = { class: "w-100 d-flex" }
const _hoisted_26 = { class: "flex-grow-1 d-flex" }
const _hoisted_27 = { class: "my-auto" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons p-button-icon" }, "content_copy", -1)
const _hoisted_29 = {
  key: 0,
  class: "w-100 position-relative"
}
const _hoisted_30 = { class: "container-bottom-middle center" }
const _hoisted_31 = {
  key: 0,
  class: "sd-sm mx-4"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "TODO", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StringConfig = _resolveComponent("StringConfig")!
  const _component_NumberConfig = _resolveComponent("NumberConfig")!
  const _component_BooleanConfig = _resolveComponent("BooleanConfig")!
  const _component_ObjectConfig = _resolveComponent("ObjectConfig")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SpeedDial = _resolveComponent("SpeedDial")!
  const _component_ConfigProperty = _resolveComponent("ConfigProperty", true)!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass((_ctx.property.hidden && _ctx.property.hidden === true) ? 'd-none' : '' )
      }, [
        (_ctx.property.type === 'string')
          ? (_openBlock(), _createBlock(_component_StringConfig, {
              key: 0,
              value: _ctx.currValue,
              "parent-information": _ctx.parentInformation,
              property: _ctx.property,
              id: _ctx.id,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateConfig(null, $event, 2000)))
            }, null, 8, ["value", "parent-information", "property", "id"]))
          : (_ctx.property.type === 'number')
            ? (_openBlock(), _createBlock(_component_NumberConfig, {
                key: 1,
                value: _ctx.currValue,
                "parent-information": _ctx.parentInformation,
                property: _ctx.property,
                id: _ctx.id,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateConfig(null, $event, 2000)))
              }, null, 8, ["value", "parent-information", "property", "id"]))
            : (_ctx.property.type === 'boolean')
              ? (_openBlock(), _createBlock(_component_BooleanConfig, {
                  key: 2,
                  value: _ctx.currValue,
                  "parent-information": _ctx.parentInformation,
                  property: _ctx.property,
                  id: _ctx.id,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateConfig(null, $event, 2000)))
                }, null, 8, ["value", "parent-information", "property", "id"]))
              : (_ctx.property.type === 'object')
                ? (_openBlock(), _createBlock(_component_ObjectConfig, {
                    key: 3,
                    value: _ctx.currValue,
                    "parent-information": _ctx.parentInformation,
                    property: _ctx.property,
                    id: _ctx.id,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateConfig(null, $event))),
                    onDelete: _cache[4] || (_cache[4] = ($event: any) => {_ctx.currValue = null; _ctx.updateConfig(null, null);})
                  }, null, 8, ["value", "parent-information", "property", "id"]))
                : (_ctx.property.type === 'array')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
                        _createElementVNode("div", {
                          class: "modal fade",
                          tabindex: "-1",
                          id: _ctx.rndId + 'sortModal'
                        }, [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t( 'tooltip.sort' )), 1),
                                _hoisted_6
                              ]),
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_VueDraggableNext, {
                                  list: _ctx.value,
                                  class: "list-group",
                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateConfig(null,null)))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (element) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "list-group-item text-center d-flex cursor-pointer",
                                        key: element
                                      }, [
                                        _hoisted_8,
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getName( element )), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["list"])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_1)
                      ])),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.property.format === 'menu')
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.$t( 'editor.menus' )), 1))
                          : (_ctx.property.format === 'module')
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.$t( 'editor.modules' )), 1))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_13, _toDisplayString(_ctx.$t( 'editor.' + _ctx.id )), 1)),
                        _withDirectives(_createVNode(_component_Button, {
                          class: "p-button-text p-button-secondary p-button-sm ms-auto",
                          icon: "bi bi-list-ol",
                          "data-bs-toggle": "modal",
                          "data-bs-target": '#' + _ctx.rndId + 'sortModal'
                        }, null, 8, ["data-bs-target"]), [
                          [_directive_tooltip, { value: _ctx.$t('tooltip.sort'), class: 'display-after-1'}]
                        ])
                      ]),
                      (_ctx.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_ctx.property.format === 'module')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_SpeedDial, {
                                    model: _ctx.getModules(-1),
                                    radius: 50,
                                    type: "circle",
                                    "button-class": "p-button-text p-button-secondary p-button-sm sd-button-sm",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, ["model"])
                                ]))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  class: "p-button-text p-button-secondary p-button-sm mx-auto",
                                  icon: "bi bi-plus",
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.addItem(0)), ["stop"]))
                                }))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.format === 'tabs')
                        ? (_openBlock(), _createBlock(_component_TabView, {
                            key: 1,
                            activeIndex: _ctx.activeIndex,
                            "onUpdate:activeIndex": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeIndex) = $event)),
                            scrollable: true,
                            onTabClick: _ctx.addItemIfLast
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, i) => {
                                return (_openBlock(), _createBlock(_component_TabPanel, null, {
                                  header: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getName( item )), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, [
                                      _withDirectives(_createVNode(_component_Button, {
                                        class: "flex-grow-1 p-button-text p-button-secondary p-button-sm",
                                        icon: "bi bi-chevron-left",
                                        disabled: i===0,
                                        onClick: _withModifiers(($event: any) => (_ctx.arrayItemToPosition(i,i-1)), ["stop"])
                                      }, null, 8, ["disabled", "onClick"]), [
                                        [_directive_tooltip, { value: _ctx.$t('tooltip.sortLeft'), class: 'display-after-1'}]
                                      ]),
                                      _withDirectives((_openBlock(), _createBlock(_component_Button, { class: "flex-grow-1 p-button-text p-button-secondary p-button-sm d-flex" }, {
                                        default: _withCtx(() => [
                                          _hoisted_18
                                        ]),
                                        _: 1
                                      })), [
                                        [_directive_tooltip, { value: _ctx.$t('tooltip.copy'), class: 'display-after-1'}]
                                      ]),
                                      _withDirectives(_createVNode(_component_Button, {
                                        class: "flex-grow-1 p-button-text p-button-secondary p-button-sm",
                                        icon: "bi bi-trash",
                                        onClick: ($event: any) => (_ctx.deleteItem(i)),
                                        disabled: _ctx.property.min >= _ctx.value.length
                                      }, null, 8, ["onClick", "disabled"]), [
                                        [_directive_tooltip, { value: _ctx.$t('tooltip.delete'), class: 'display-after-1'}]
                                      ]),
                                      _withDirectives(_createVNode(_component_Button, {
                                        class: "flex-grow-1 p-button-text p-button-secondary p-button-sm",
                                        icon: "bi bi-chevron-right",
                                        disabled: i===_ctx.value.length-1,
                                        onClick: _withModifiers(($event: any) => (_ctx.arrayItemToPosition(i,i+1)), ["stop"])
                                      }, null, 8, ["disabled", "onClick"]), [
                                        [_directive_tooltip, { value: _ctx.$t('tooltip.sortRight'), class: 'display-after-1'}]
                                      ])
                                    ]),
                                    (_openBlock(), _createBlock(_component_ConfigProperty, {
                                      class: "grid-element",
                                      property: _ctx.getConfigByObject(_ctx.property.items, item),
                                      value: item,
                                      id: item.name,
                                      onChange: ($event: any) => (_ctx.updateConfig(i,$event)),
                                      key: _ctx.reload
                                    }, null, 8, ["property", "value", "id", "onChange"]))
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256)),
                              _createVNode(_component_TabPanel, null, {
                                header: _withCtx(() => [
                                  _hoisted_19
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["activeIndex", "onTabClick"]))
                        : (_openBlock(), _createBlock(_component_Accordion, {
                            key: 2,
                            class: "w-100 p-2 array-accordion",
                            activeIndex: _ctx.activeIndex
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, i) => {
                                return (_openBlock(), _createBlock(_component_AccordionTab, { headerClass: "accordion-flex-header accordion-small-header" }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: "position-relative w-100",
                                      id: _ctx.rndId.toString() + i.toString()
                                    }, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                          (_ctx.property.format === 'module')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _hoisted_24,
                                                (_ctx.open < 0 || _ctx.open === i)
                                                  ? (_openBlock(), _createBlock(_component_SpeedDial, {
                                                      key: 0,
                                                      model: _ctx.getModules(i-1),
                                                      type: "circle",
                                                      "button-class": "p-button-text p-button-secondary p-button-sm sd-button-sm p-button-rounded bg-white border",
                                                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                                                      onShow: ($event: any) => (_ctx.openSpeedDial(i)),
                                                      onHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openSpeedDial(-1))),
                                                      "show-icon": "bi bi-plus",
                                                      "hide-icon": "bi bi-x",
                                                      radius: 50,
                                                      "tooltip-options": {position: 'left'}
                                                    }, null, 8, ["model", "onShow"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                                key: 1,
                                                class: "p-button-text p-button-secondary p-button-sm m-0 p-button-rounded bg-white border sd-button-sm",
                                                icon: "bi bi-plus",
                                                onClick: _withModifiers(($event: any) => (_ctx.addItem(i-1)), ["stop"])
                                              }, null, 8, ["onClick"])), [
                                                [_directive_tooltip, { value: _ctx.$t('tooltip.add'), class: 'display-after-1'}]
                                              ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getName( item )), 1)
                                        ]),
                                        _withDirectives(_createVNode(_component_Button, {
                                          class: "p-button-text p-button-secondary p-button-sm m-0",
                                          icon: "bi bi-trash",
                                          onClick: _withModifiers(($event: any) => (_ctx.deleteItem(i)), ["stop"])
                                        }, null, 8, ["onClick"]), [
                                          [_directive_tooltip, { value: _ctx.$t('tooltip.delete'), class: 'display-after-1'}]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                          class: "p-button-text p-button-secondary p-button-sm m-0",
                                          onClick: _withModifiers(($event: any) => (_ctx.copyItem(i)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_28
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])), [
                                          [_directive_tooltip, { value: _ctx.$t('tooltip.copy'), class: 'display-after-1'}]
                                        ]),
                                        _withDirectives(_createVNode(_component_Button, {
                                          icon: "bi bi-chevron-up",
                                          class: "p-button-text p-button-secondary p-button-sm hide-first m-0",
                                          onClick: _withModifiers(($event: any) => (_ctx.arrayItemToPosition(i,i-1)), ["stop"])
                                        }, null, 8, ["onClick"]), [
                                          [_directive_tooltip, { value: _ctx.$t('tooltip.sortUp'), class: 'display-after-1'}]
                                        ]),
                                        _withDirectives(_createVNode(_component_Button, {
                                          icon: "bi bi-chevron-down",
                                          class: "p-button-text p-button-secondary p-button-sm hide-last m-0",
                                          onClick: _withModifiers(($event: any) => (_ctx.arrayItemToPosition(i,i+1)), ["stop"])
                                        }, null, 8, ["onClick"]), [
                                          [_directive_tooltip, { value: _ctx.$t('tooltip.sortDown'), class: 'display-after-1'}]
                                        ])
                                      ]),
                                      (_ctx.value.length - 1 === i)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                              (_ctx.property.format === 'module')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                    _hoisted_32,
                                                    (_ctx.open < 0 || _ctx.open === (i+1))
                                                      ? (_openBlock(), _createBlock(_component_SpeedDial, {
                                                          key: 0,
                                                          model: _ctx.getModules(i),
                                                          type: "circle",
                                                          "button-class": "p-button-text p-button-secondary p-button-sm sd-button-sm p-button-rounded bg-white border",
                                                          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                                                          onShow: ($event: any) => (_ctx.openSpeedDial(i)),
                                                          onHide: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openSpeedDial(-1))),
                                                          "show-icon": "bi bi-plus",
                                                          "hide-icon": "bi bi-x",
                                                          radius: 50,
                                                          "tooltip-options": {position: 'left'}
                                                        }, null, 8, ["model", "onShow"]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                                    key: 1,
                                                    class: "p-button-text p-button-secondary p-button-sm m-0 p-button-rounded bg-white border sd-button-sm",
                                                    icon: "bi bi-plus",
                                                    onClick: _withModifiers(($event: any) => (_ctx.addItem(i)), ["stop"])
                                                  }, null, 8, ["onClick"])), [
                                                    [_directive_tooltip, { value: _ctx.$t('tooltip.add'), class: 'display-after-1'}]
                                                  ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_20)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_component_ConfigProperty, {
                                      class: "grid-element",
                                      property: _ctx.getConfigByObject(_ctx.property.items, item),
                                      value: item,
                                      id: item.name,
                                      onChange: ($event: any) => (_ctx.updateConfig(i,$event)),
                                      key: _ctx.reload
                                    }, null, 8, ["property", "value", "id", "onChange"]))
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["activeIndex"]))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createTextVNode(_toDisplayString(_ctx.property) + " ", 1),
                      _hoisted_33
                    ], 64))
      ], 2))
    : _createCommentVNode("", true)
}